class GiftShip {
  constructor() {
    this.selector = {
      fieldSet: document.querySelectorAll('.gs__product-option fieldset'),
      optionToggle: document.querySelectorAll('.gs__product-option fieldset legend')
    }

    this.initEvents();    
  }

  toggleOptions(e) {
    if (e.target.parentNode.classList.contains('active')) {
      e.target.parentNode.classList.remove('active');
    } else {
      e.target.parentNode.classList.add('active');
    }
  }

  initEvents() {
    this.selector.optionToggle.forEach(element => {
      element.addEventListener('click', this.toggleOptions.bind(this));
    });
  }
}



const giftShipInterval = setInterval(inializer, 1000)

function inializer() {
  if (document.querySelector('#gsAppContainer #gsBundlePrices')) {
    new GiftShip();
    clearInterval(giftShipInterval);
  }
}


/*
class DeliveryDate {
  constructor(props) {
    this.element = document.querySelector(props);
    this.selector = {
      earliestDate: document.querySelector('span[earliest-date]')
    };

    this.months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    this.init();
  }

  addDays(days) {
    let cloneDate = new Date();
    cloneDate.setDate(cloneDate.getDate() + parseInt(days));
    return cloneDate;
  }

  init() {
    const value = this.element.getAttribute('data-value').split('-');
    const number = value[0]; //get the first index
    const today = new Date();
    const newDate = this.addDays(number);

    let deliveryText = "Tomorrow";
    if (Math.abs(today.getDate() - newDate.getDate()) > 1) {
      deliveryText = `${this.months[newDate.getMonth()]} ${newDate.getDate()}`;
    }
    this.selector.earliestDate.textContent = deliveryText;
  }
}

if (document.querySelector('[earliest-delivery-date]')) {
  new DeliveryDate('[earliest-delivery-date]');
}
*/

function getUnavailableDates() {
  const deliveryContainer = document.querySelector(".product-delivery__container")
  
  if (!deliveryContainer) {
    // Handle the case where the element doesn't exist
      return [];
  }
  
  const datesUnavailable = deliveryContainer.getAttribute('data-unavailable-dates')
  const datesUnavailableArray = datesUnavailable.split(',')
  return datesUnavailableArray
}

function setEarliestDeliveryDate() {
  const dateToday = Date.today().toString("dd-MM-yyyy")
  const dateTomorrow = Date.parse("tomorrow")
  const isWeekday = Date.today().is().weekday()
  const isWeekend = !Date.today().is().weekday()
  const unavailableDates = getUnavailableDates()
  const isUnavailableToday = unavailableDates.includes(dateToday)
  let earliestDateEl = document.querySelector('span[earliest-date]');

  if (!earliestDateEl) {
    return false;
  }
  
  if (isWeekend) {
    if (unavailableDates.includes(Date.today().next().monday().toString("dd-MM-yyyy"))) {
    	earliestDateEl.innerText = Date.today().next().tuesday().toString("MMM dd")
    } else {
    	earliestDateEl.innerText = Date.today().next().monday().toString("MMM dd")
    }
  } 
  
  if (isUnavailableToday) {
    if (Date.today().is().friday()) {
    	earliestDateEl.innerText = Date.today().next().monday().toString("MMM dd")
    } else {
    	earliestDateEl.innerText = dateTomorrow.toString("MMM dd")
    }
  }
  
  if (isWeekday) {
    if (unavailableDates.includes(Date.today().add(2).day().toString("dd-MM-yyyy"))
       ||unavailableDates.includes(Date.today().add(3).day().toString("dd-MM-yyyy"))
       || unavailableDates.includes(Date.today().add(4).day().toString("dd-MM-yyyy"))
       || Date.today().add(2).day() == Date.parse("next saturday") 
       || Date.today().add(2).day() == Date.parse("next sunday")) {
    	earliestDateEl.innerText = Date.today().next().monday().toString("MMM dd")
    } else {
    	earliestDateEl.innerText = Date.today().add(2).day().toString("MMM dd")
    }
  } 
  
  console.log("is this true", unavailableDates.includes(Date.today().add(2).day().toString("dd-MM-yyyy")))
  
  return false
}

setEarliestDeliveryDate()
